<form #form="ngForm" class="container-form-sc" novalidate (submit)="onSave()" *ngIf="isOpen">
    <!--Options-->
    <div class="row container-form-sc-options">
        <div class="col-12">
            <button type="submit" class="btn btn-link btn-link-success">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-link" (click)="onCancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-sc-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="form-group col-12">
                    <label for="subRegiaoNome" class="col-form-label">Nome</label>
                    <input type="text" class="form-control" [(ngModel)]="entity.nome" name="subRegiaoNome" id="subRegiaoNome"
                        #subRegiaoNome="ngModel" maxlength="255" [autofocus]="true" required="required">
                    <sgt-form-control-error
                        *ngIf="subRegiaoNome.errors && subRegiaoNome.errors.required && subRegiaoNome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="subRegiaoNome.errors && subRegiaoNome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="classificacaoSubRegiao" class="col-form-label">Classificação</label>
                    <select class="form-control" name="classificacaoSubRegiao" id="classificacaoSubRegiao"
                        [ngModel]="entity.classificacao || ''" (ngModelChange)="entity.classificacao = $event ? $event : null"
                        #classificacaoSubRegiao="ngModel">
                        <option value="">Selecione a classificação...</option>
                        <option *ngFor="let classificacao of classificacoes" [ngValue]="classificacao.id">{{classificacao.nome}}</option>
                    </select>
                </div>
            </div>
            <!-- Bairros -->
            <div class="row">
                <div class="col-12">
                    <sgt-cidade-sub-regiao-bairro
                        [entities]="entity.bairros"
                        #cidadeSubRegiaoBairroCadastro>
                    </sgt-cidade-sub-regiao-bairro>
                </div>
            </div>
        </div>
    </div>
</form>
